/**
 * User-facing names for the app's main sections.
 *
 * These live in one place because they were previously written 2–3 times each:
 * `Navbar.js` renders two fully duplicated menu trees (mobile and desktop), `UserHome.js`
 * repeats the same destinations as cards, and each page repeats its own title. A rename
 * meant hunting every copy — and the client has said more renames are coming.
 *
 * The wording is the client's and is deliberate: 가상 고객과 롤플레이, not 가상 고객
 * 롤플레이; 내 직원 관리하기, not 내 직원 관리. Change these only against a written
 * request, and add new entries here rather than inlining a string at a call site.
 */
export const NAV = {
  // was 응대 시뮬레이션 (UI UX_수정요청서_v1.0, request 2)
  ROLEPLAY: "가상 고객과 롤플레이",

  // was 제품 지식 트레이닝 (request 11)
  QUIZ: "제품 지식 퀴즈",
  // was 맞춤형 퀴즈로 제품 지식을 강화하세요 (request 12)
  QUIZ_SUBTITLE: "퀴즈를 풀고 제품에 대한 지식을 강화하세요.",

  // /userslist — the screen that manages individual staff: search, sort, 승인/취소,
  // per-person 롤플레이 기록 and dashboard, scoped to the admin's own contractor.
  //
  // Request 16 asked for 내 직원 관리하기 and #113 put that label on /admin/contractors,
  // which lists 파트너 *organisations* and shows a 파트너 관리자 exactly one row — so the
  // menu promising it was the one that could not manage staff. #136 moved the label here.
  // The client then shortened it to 직원 관리 (2026-08-06), dropping the 내 that made it
  // read as personal rather than administrative.
  MY_STAFF: "직원 관리",

  // /admin/contractors, named for who is looking at it.
  //
  // 파트너 replaced 소속사 at the client's request (2026-08-06), everywhere it was
  // user-visible — not just this label. It matches what the product already said in two
  // places: the 롤플레이 기록 table's 파트너 column renders `trainee.contractor.name`, and
  // Apple's own score-sheet header is 파트너사 명.
  //
  // The model is still `Contractor` and the route is still /admin/contractors. Renaming
  // those is a migration, not a copy change, and the label layer exists precisely so the
  // client's vocabulary can move without one.
  //
  // A 파트너 관리자 sees only their own org here, and its remaining use for them is
  // 초대 링크 and 관리자 지정 — the two things they cannot do anywhere else, which is why
  // the menu is renamed for them rather than hidden. Its 승인 대기 tab is redundant with
  // MY_STAFF. That wording went to the client as 가칭 and has not been answered.
  CONTRACTORS: "파트너 관리",
  CONTRACTOR_ACCESS: "초대 · 권한 관리",

  SESSIONS: "롤플레이 기록",
  // Quiz attempts, for trainees (their own) and admins (everyone in scope); the admin
  // menu has called it this since the page was admin-only.
  QUIZ_HISTORY: "퀴즈 기록",
  QUIZ_HISTORY_SUBTITLE: "푼 문제와 채점 결과, 해설을 확인하세요.",
  // The trainee's own dashboard (/userdashboard), as the menus have always called it.
  DASHBOARD: "나의 대시보드",
  // New with the phone page header (was the English "View chat history"); not client copy yet.
  SESSIONS_SUBTITLE: "지난 롤플레이와 평가 결과를 확인하세요.",
};

export default NAV;
